import { render } from "./userFormDefined.vue?vue&type=template&id=3f8503b1"
import script from "./userFormDefined.vue?vue&type=script&lang=js"
export * from "./userFormDefined.vue?vue&type=script&lang=js"

import "./userFormDefined.vue?vue&type=style&index=0&id=3f8503b1&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__